var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGalleryExport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46306 9.18687C8.37896 9.18687 9.12144 8.44439 9.12144 7.52849C9.12144 6.6126 8.37896 5.87012 7.46306 5.87012C6.54717 5.87012 5.80469 6.6126 5.80469 7.52849C5.80469 8.44439 6.54717 9.18687 7.46306 9.18687Z",
    stroke: "#5A5E6E",
    strokeWidth: 1.57109,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7773 2.55347H7.46057C3.31463 2.55347 1.65625 4.21184 1.65625 8.35779V13.3329C1.65625 17.4789 3.31463 19.1372 7.46057 19.1372H12.4357C16.5816 19.1372 18.24 17.4789 18.24 13.3329V9.18698",
    stroke: "#5A5E6E",
    strokeWidth: 1.57109,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9258 7.5286V2.55347L16.5842 4.21184",
    stroke: "#5A5E6E",
    strokeWidth: 1.57109,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.924 2.55347L13.2656 4.21184",
    stroke: "#5A5E6E",
    strokeWidth: 1.57109,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21289 16.6082L6.30079 13.8636C6.95585 13.4241 7.90112 13.4739 8.48985 13.9797L8.76348 14.2201C9.41025 14.7757 10.455 14.7757 11.1018 14.2201L14.5512 11.2599C15.198 10.7044 16.2428 10.7044 16.8895 11.2599L18.2411 12.4208",
    stroke: "#5A5E6E",
    strokeWidth: 1.57109,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryExport);
export default __webpack_public_path__ + "static/media/gallery-export.36b48a2d2eae15ee9f251cc1e1d78b08.svg";
export { ForwardRef as ReactComponent };